import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Icon_info_hover",
  "use": "icon-Icon_info_hover-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Icon_info_hover\">\n  <g id=\"icon-Icon_info_hover_Group_1136\" data-name=\"Group 1136\" transform=\"translate(-51 -1445)\">\n    <path id=\"icon-Icon_info_hover_Path_328\" data-name=\"Path 328\" d=\"M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z\" transform=\"translate(51 1445)\" fill=\"#2d2d2d\" />\n    <g id=\"icon-Icon_info_hover_np_info_3012852_000000\" transform=\"translate(47.875 1441.875)\">\n      <path id=\"icon-Icon_info_hover_Union_7\" data-name=\"Union 7\" d=\"M8,12.267a.5.5,0,0,1-.533-.533v-4.8a.533.533,0,1,1,1.067,0v4.8A.5.5,0,0,1,8,12.267ZM8,5.333A.5.5,0,0,1,7.467,4.8V3.733a.533.533,0,1,1,1.067,0V4.8A.5.5,0,0,1,8,5.333Z\" transform=\"translate(3.125 3.126)\" fill=\"#ededed\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/Icon_info_hover.svg
// module id = 91
// module chunks = 0 1 2